import React from 'react'
import Breadcrumbs from 'components/atomic/Breadcrumbs'
import MetaSeo from 'components/atomic/MetaSeo'
import { api } from 'utils'
import { CardAdozionale } from 'react-components/molecules'
import { FiltriCatalogo } from 'react-components/organisms'
import { useTrans } from 'hooks'
import { SHOP, SLUG, GET_LISTING, PAGINEDETAIL } from '../../utils/endpoint'
import Pagination from 'components/atomic/Pagination'
import { useRouter } from 'next/router'
import { PROGETTI_SPECIALI } from '../../utils'
import Default from 'components/template/Default'
import { api as pagebuilderApi } from 'react-pagebuilder/services/api'

const ShopDetail = ({
  listingShop,
  items,
  pagina,
  paginator,
  filters,
  generalPage,
  newPlaceholder,
  newDefaultContent,
}) => {
  if (!generalPage && !pagina) {
    return <Error statusCode={statusCode} />
  }

  const t = useTrans()
  const router = useRouter()

  const handlePaginationClick = (page) => {
    let url = router.asPath
    if (url.match(/p\/\d+/)) {
      url = url.replace(/p\/\d+/g, `p/${page}`)
    } else {
      url = url + `/p/${page}`
    }

    router.push(url)
  }

  return generalPage ? (
    <>
      <MetaSeo seo={pagina.seo} />
      <Default
        page={pagina}
        newPlaceholder={newPlaceholder}
        tabs={null}
        content={newDefaultContent}
      />
    </>
  ) : (
    <main className="listing-shop">
      <MetaSeo seo={pagina.seo} />
      <div className="listing-shop__container">
        <Breadcrumbs breadcrumbs={pagina.breadcrumbs} />
        <h1 className="listing-shop__titolo">{listingShop.titolo}</h1>
        <h2 className="listing-shop__descrizione">{listingShop.descrizione}</h2>
        <div className="listing-shop__filtri">
          {filters.map((filter) => (
            <FiltriCatalogo
              className="listing-shop__discipline"
              label={t(filter.name)}
              filtri={filter.innerFilters}
            />
          ))}
        </div>
      </div>
      <div className="listing-shop__round-corner">
        <div className="listing-shop__list">
          {items.map((item, index) => (
            <CardAdozionale
              adozionale={item}
              key={item.id}
              position={index + 1}
              parentList={'navigazione_standard'}
            />
          ))}
        </div>
        <Pagination
          pagination={paginator}
          currentPage={parseInt(paginator.current_page)}
          handleChangePage={(page) => {
            handlePaginationClick(page)
          }}
        />
      </div>
    </main>
  )
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  }
}

export const getStaticProps = async ({ params: { params }, preview, previewData }) => {
  const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

  if (params) {
    const slug = params[0]
    let response = await api.get(`${SHOP}${SLUG}${slug}/`, {
      headers,
      params: { preview: preview },
    })
    let listingShop = response.data

    if (!listingShop) {
      return {
        notFound: true,
      }
    }

    const pagina = listingShop.pagina

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    const keys = ['p', 'f']
    const extractedParams = {}

    if (params) {
      const paramsArray = [...params]

      keys.forEach((key) => {
        const keyIndex = paramsArray.indexOf(key)
        if (keyIndex !== -1) {
          let values = []
          let currentIndex = keyIndex + 1
          let nextKeyIndex = -1

          // Find the next key index
          for (let i = currentIndex; i < paramsArray.length; i++) {
            if (keys.includes(paramsArray[i])) {
              nextKeyIndex = i
              break
            }
          }

          // Extract values for the current key
          if (nextKeyIndex !== -1) {
            values = paramsArray.slice(currentIndex, nextKeyIndex)
          } else {
            values = paramsArray.slice(currentIndex)
          }

          // Store the extracted values in the dictionary
          extractedParams[key] = values.length > 1 ? values : values[0]
        }
      })
    }

    response = await api.get(`${SHOP}${GET_LISTING}`, {
      params: { params: extractedParams, slug: params[0] },
      headers,
    })
    const items = response.data.elementi
    const paginator = response.data.paginator
    const filters = response.data.filtri
    return {
      props: {
        listingShop,
        pagina: pagina,
        items: items,
        paginator: paginator,
        filters: filters,
        revalidate: 60, // trovare alternativa in stile data-fetching-wrapper di Luca D. per altre pagine senza dover passare manualmente il revalidate
      },
      revalidate: 60,
    }
  } else {
    const params = {
      path: '/shop',
      preview,
    }

    const result = await api.get(PAGINEDETAIL, { params, headers })
    let page = await result.data

    if (!page) {
      return {
        notFound: true,
      }
    }

    let newPlaceholder = null
    let newDefaultContent = null

    if (page.template !== PROGETTI_SPECIALI) {
      newPlaceholder = await pagebuilderApi.getPagebuilder({
        contentTypeId: page.model,
        objectId: page.id,
        key: 'content',
        edit_mode: false,
      })

      if (page.tabs.length) {
        newDefaultContent = await pagebuilderApi.getPagebuilder({
          contentTypeId: page.model,
          objectId: page.id,
          key: page.id + '-' + page.tabs[0].slug + '-content',
          edit_mode: false,
        })
      }
    }

    const toolbarProps = { toolbarPage: page, toolbarItem: page }

    if (!page.chiave) {
      page = { ...page, chiave: page.path } // per far funzionare la ricerca
    }

    return {
      props: {
        pagina: page,
        items: [],
        generalPage: true,
        newPlaceholder: newPlaceholder,
        newDefaultContent: newDefaultContent,
        ...toolbarProps,
        revalidate: 60 * 2, // trovare alternativa in stile data-fetching-wrapper di Luca D. per altre pagine senza dover passare manualmente il revalidate
      },
      revalidate: 60 * 2,
    }
  }
}

export default ShopDetail
